import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';

import {
  Header,
  Icon
} from '../../components';

import './styles.scss';

export const RevisionRequest = () => {
  const { t } = useTranslation();

  return (
    <div className='revision-request'>
      <Header
        title={t('services.revisionRequest')}
        showBackbutton={true}
      />
      <Outlet />
      <Icon type='personConstancy' className='revision-request__icon' />
    </div>
  );
};

export default RevisionRequest;
